// ImageList.jsx
import React, { useEffect, useState } from 'react';
import {
  DndContext,
  closestCenter
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  rectSortingStrategy,
} from '@dnd-kit/sortable';

import { SortableImage } from './SortableImage';
import { ImageTemp, ImageType } from '../../interfaces/intakes.reports';


interface Props {
  initialImages: (ImageTemp | ImageType)[]
  updatedOrder: (images: (ImageTemp | ImageType)[]) => void
  className?: string
}

export function SortableList({ initialImages = [], updatedOrder, className }: Props) {

  const normalizeImages = (imgs: (ImageTemp | ImageType)[]) => {
    return imgs.map(img => 'id' in img ? img : { ...img, id: img.key })
  }

  const [images, setImages] = useState(normalizeImages(initialImages));

  useEffect(() => {
    setImages(normalizeImages(initialImages));
  }, [initialImages])

  useEffect(() => {
    if (images !== initialImages) {
      updatedOrder(images);
    }
  }, [images]);


  function handleDragEnd(event: any) {
    const { active, over } = event;

    if (active.id !== over.id) {
      setImages((items) => {
        const oldIndex = items.findIndex((item) => item.id === active.id);
        const newIndex = items.findIndex((item) => item.id === over.id);

        // arrayMove es una función útil que te da dnd-kit
        return arrayMove(items, oldIndex, newIndex);
      });
    }
  }

  return (
    <DndContext
      collisionDetection={closestCenter}
      onDragEnd={(e) => {
        document.body.style.overflow = "";
        handleDragEnd(e)
      }}

      onDragStart={() => {
        document.body.style.overflow = "hidden";
      }}
    >
      <SortableContext
        items={images}
        strategy={rectSortingStrategy} // Estrategia para grids
      >
        {/* <div style={{ display: 'flex', flexWrap: 'wrap' }}> */}
        <div className={`tw-grid tw-grid-cols-4 sm:tw-grid-cols-4 ${className || ''}`}>
          {images.map(image => <SortableImage key={image.id} image={image} />)}
        </div>
      </SortableContext>
    </DndContext>
  );
}